export const GET_WEATHER_API_REQUEST = "GET_WEATHER_API_REQUEST"
export const GET_WEATHER_API_SUCCESS = "GET_WEATHER_API_SUCCESS"
export const GET_WEATHER_API_FAILURE = "GET_WEATHER_API_REQUEST"

export const GET_FORECAST_API_REQUEST = 'GET_FORECAST_API_REQUEST';
export const GET_FORECAST_API_SUCCESS = 'GET_FORECAST_API_SUCCESS';
export const GET_FORECAST_API_FAILURE = 'GET_FORECAST_API_FAILURE';